// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1l8IE","topBottomGutter":"Layout_topBottomGutter__3v9aL"};